import { useAllCouriersQuery } from 'core/graphql/Couriers/AllCouriers.generated';
import { Courier } from 'core/graphql/types';

type CouriersResult = {
  loading: boolean;
  couriers: Array<Courier>;
};

const useAllCouriersDataStore = (): CouriersResult => {
  const { loading, data } = useAllCouriersQuery();

  if (data !== undefined) {
    return {
      couriers: data.AllCouriers,
      loading,
    };
  }

  return {
    couriers: [],
    loading,
  };
};

export default useAllCouriersDataStore;
